'use strict';

/*jshint unused: false*/
var JobTypeComponent = {
  bindings: {
    type: '<',
    base: '<',
  },
  controller: /*@ngInject*/ function (JOB_TYPE) {
    var _self = this;

    _self.syncType = function () {
      if (!_self.type) {
        return;
      }

      _self.id = JOB_TYPE.icons[_self.type];
      _self.iconType = _self.id;
    };

    _self.$onInit = function () {
      _self.syncType();
    };

    _self.$onChanges = function (changes) {
      if (changes.type) {
        _self.syncType();
      }
    };
  },
  templateUrl: 'templates/partials/ui/jobType.tpl.html',
};

module.exports = JobTypeComponent;
